export const DELIVERY_COST = 120;
export const EMAIL_REGEX = /\S+@\S+\.\S+/;
export const PHONE_REGEX = /\+7\(\d{3}\)-\d{3}-\d{2}-\d{2}/;

export const CONTACTS = {
	phone: {
		text: '8 800 250-13-11',
		link: 'tel:88002501311',
	},
	email: {
		text: 'info@app73.pro',
		link: 'mailto:info@app73.pro',
	},
	telegram: {
		text: 'Telegram',
		link: 'https://t.me/APP73BOT',
	},
	autoTransportation: {
		text: 'Автоперевозки',
		link: 'https://app73.pro/',
	},
	railTransportation: {
		text: 'Железнодорожные перевозки',
		link: 'https://train73.pro',
		// link: 'http://localhost:3000',
	},
} as const;

export const STORAGE_KEY = {
	calculator: 'calculator',
} as const;
